<template>
  <div>
      <h1 class="page-title">
          Choose Plan
      </h1>
      <div v-if="loading" class="page-loading-container">
          <b-spinner label="Loading..." ></b-spinner>
      </div>
      <div v-else>
          <b-row>
              <b-col xs="3" md="3">
                  <Widget
                          style="text-align:center;border:0px solid #95d0ff;padding-left:2px;padding-right:2px">
                      <h3>Individual</h3>
                      <div class="pricing">
                          <sup>$</sup>9<span class="monthindicator">/month</span></div>

                      <div>
                          <ul style="text-align:left;margin-left:8px;line-height:30px">
                              <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:18px;"></i> Unlimited 1 page audits<br><small style="margin-left:20px">$0.10 per extra page</small></li>
                              <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> Up to 3 devices</li>
                              <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> Includes all checks</li>
                              <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> Cancel any time</li>
                          </ul>
                      </div>
                      <b-button :to="{ name: 'NewPage', query: {plan: 'startup'} }" variant="primary" style="float:bottom">
                          <span >Subscribe</span>
                      </b-button>
                  </Widget>
              </b-col>
              <b-col xs="3" md="3">
                  <Widget
                          style="text-align:center;border:0px solid #95d0ff;padding-left:2px;padding-right:2px">
                      <h3>Startup</h3>
                      <div class="pricing">
                          <sup>$</sup>29<span class="monthindicator">/month</span></div>

                      <div>
                          <ul style="text-align:left;margin-left:8px;line-height:30px">
                              <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:18px;"></i> Unlimited 5 page audits<br><small style="margin-left:20px">$0.10 per extra page</small></li>
                              <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> Up to 4 devices</li>
                              <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> Includes all checks</li>
                              <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> Cancel any time</li>
                          </ul>
                      </div>
                      <b-button :to="{ name: 'NewPage', query: {plan: 'startup'} }" variant="primary" style="float:bottom">
                          <span >Subscribe</span>
                      </b-button>
                  </Widget>
              </b-col>
                  <b-col xs="3" md="3">
                      <Widget
                              style="text-align:center;border:0px solid #95d0ff;padding-left:2px;padding-right:2px">
                          <h3>Business</h3>
                          <div class="pricing">
                              <sup>$</sup>79<span class="monthindicator">/month</span></div>

                          <div>
                              <ul style="text-align:left;margin-left:8px;line-height:30px">
                                  <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:18px;"></i> Unlimited 25 page audits<br><small style="margin-left:20px">$0.10 per extra page</small></li>
                                  <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> Up to 6 devices</li>
                                  <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> Includes all checks</li>
                                  <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> Cancel any time</li>
                              </ul>
                          </div>
                          <b-button :to="{ name: 'NewPage', query: {plan: 'startup'} }" variant="primary" style="float:bottom">
                              <span >Subscribe</span>
                          </b-button>
                      </Widget>
                </b-col>
                  <b-col xs="3" md="3">
                      <Widget
                              style="text-align:center;border:0px solid #95d0ff;padding-left:2px;padding-right:2px">
                          <h3>Agency</h3>
                          <div class="pricing">
                              <sup>$</sup>139<span class="monthindicator">/month</span></div>

                          <div>
                              <ul style="text-align:left;margin-left:8px;line-height:30px">
                                  <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:16px;"></i> Unlimited 50 page audits<br><small style="margin-left:20px">$0.10 per extra page</small></li>
                                  <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:16px;"></i> Up to 6 devices</li>
                                  <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:16px;"></i> White Label Reports</li>
                                  <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:16px;"></i> Cancel any time</li>
                              </ul>
                          </div>
                          <b-button >
                              <span >Coming Soon</span>
                          </b-button>
                      </Widget>
                  </b-col>
              </b-row>


      </div>
  </div>
</template>

<script>
import Widget from "@/components/Widget/Widget";
import axios from "axios";
import { mapState } from 'vuex';
export default {
  name: "New",
  components: { Widget },
  computed: {
    ...mapState({ user: 'user'}),
  },
  data() {
    return {
      loading: false,
    };
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'New Site - PageWatch.dev',
    // all titles will be injected into this template
  },
  methods: {

  },
  mounted() {
  },
  created() {
  }
};
</script>

<style lang="scss">
    .pricing-info{
        color:gray;
        font-size:95%;
    }
    .log-dropdown{
        position:relative;
        left:2px;
        top:-2px;
    }
    .devices{
        div{
            min-height:1rem;
        }
    }
</style>
